import { BASE, COLOR, COLUMN, FORMATTING, JARGON, LAYOUT, POSITION, TENSE } from "../../modules/constants"
import { addPaddingRightToLastCell, calcStats, firstToLast, getCell, getCellWithTooltip, headCell, setStats } from "../../modules/table.funcs"
import { formatDate, formatInteger, fromDateUnknown, isFarFutureDate } from "../../modules/utilities"
import { commonLseTableData } from "./CreateLseCommonTableData"
import { initStats2 } from "../../components/layout/InitStats"

const { border1, date, float, integer, left, normal, number, percent, right, string, yearsMonths } = FORMATTING
const stats = {}
const borderLeft = border1
const boardWidth = "9%"
const ageWidth = "5%"
const payWidth = "8%"
// const radio = RADIO[BASE.LSE.ROLES].BOARD
// const tabIndex = TAB[BASE.LSE.ROLES].INDEX

export const createLseRolesHeadersData = props => {
    // console.log('createLseRolesHeadersData props:', props)
    const { portrait, showLogos } = props

    const company = headCell({
        paddingLeft: showLogos ? 0 : LAYOUT.HOME.PADDING.BORDER,
        align: left,
        id: COLUMN.COMPANY,
        label: "Company",
    })

    const boardRole = headCell({
        align: left,
        borderLeft,
        id: COLUMN.ROLE,
        paddingLeft: LAYOUT.HOME.PADDING.BORDER,
    })

    const from = headCell({
        id: COLUMN.FROM,
        width: boardWidth,
    })

    const until = headCell({
        id: COLUMN.UNTIL,
        width: boardWidth,
    })

    const tenure = headCell({
        id: COLUMN.TENURE,
        width: boardWidth,
    })

    const compensation = headCell({
        id: COLUMN.COMPENSATION,
        width: payWidth,
    })

    const sex = headCell({
        id: COLUMN.SEX,
        width: ageWidth,
    })

    const officer = headCell({
        align: left,
        id: COLUMN.OFFICER,
    })

    const age = headCell({
        borderLeft,
        id: COLUMN.AGE,
        width: ageWidth,
    })

    const headerCells = portrait
        ? [company, officer]
        : [company, officer, boardRole, from, until, tenure, compensation, age, sex]

    if (showLogos) {
        const logoHead = headCell({
            align: left,
            id: COLUMN.LOGO,
            width: LAYOUT.LOGO_WIDTH,
        })

        headerCells.splice(0, 0, logoHead) // insert logo header
    }

    addPaddingRightToLastCell(headerCells)

    return headerCells
}

export const createLseRolesFootersData = props => {
    // console.log('createLseRolesFootersData props:', props)
    const { portrait, showLogos } = props

    let column = null

    for (const property in stats)
        calcStats(stats[property])

    column = COLUMN.COMPANY
    const company = {
        total: getCell({
            align: left,
            column,
            paddingLeft: showLogos ? 0 : LAYOUT.HOME.PADDING.BORDER,
            suffix: ` ${stats[column].total === 1 ? JARGON.APPT : JARGON.APPTS}`,
            type: integer,
            value: stats[column].total,
        }),
        mean: getCell({
            align: left,
            column,
            paddingLeft: showLogos ? 0 : LAYOUT.HOME.PADDING.BORDER,
        }),
    }

    column = COLUMN.ROLE
    const boardRole = {
        total: getCell({ borderLeft, column }),
        mean: getCell({ borderLeft, column }),
    }

    column = COLUMN.OFFICER
    const officer = {

        total: getCell({ column }),
        mean: getCell({ column }),
    }

    column = COLUMN.FROM
    const from = {
        total: getCell({
            column,
        }),
        mean: getCell({
            column,
        }),
    }

    column = COLUMN.UNTIL //  COLUMN.LEGEND
    const legend = {
        total: getCell({
            column,
            label: "Total:",
        }),
        mean: getCell({
            column,
            label: "Average:",
        }),
    }

    column = COLUMN.TENURE
    const tenure = {
        total: getCell({
            column,
            type: integer,
            suffix: "yr",
            value: stats[column].total
        }),
        mean: getCell({
            column,
            type: yearsMonths,
            value: stats[column].mean,
        }),
    }

    column = COLUMN.COMPENSATION
    const compensation = {
        total: getCell({
            column,
            type: integer,
            value: stats[column].total
        }),
        mean: getCell({
            column,
            type: integer,
            value: stats[column].mean,
        }),
    }

    column = COLUMN.AGE
    const age = {
        total: getCell({
            borderLeft,
            column,
            type: integer,
            value: stats[column].total
        }),
        mean: getCell({
            borderLeft,
            column,
            type: float,
            value: stats[column].mean,
        }),
    }
    // console.log('age:', age)

    column = COLUMN.SEX
    const sex = {
        total: getCell({
            column,
            suffix: " F",
            type: integer,
            value: stats[column].total,

        }),
        mean: getCell({
            column,
            suffix: "% F",
            type: percent,
            value: stats[column].mean,
        }),
    }

    const footCells = {
        totals: portrait
            ? [company.total, officer.total]
            : [company.total, officer.total, boardRole.total, from.total, legend.total, tenure.total, compensation.total, age.total, sex.total],

        means: portrait
            ? [company.mean, officer.mean]
            : [company.mean, officer.mean, boardRole.mean, from.mean, legend.mean, tenure.mean, compensation.mean, age.mean, sex.mean],
    }

    if (showLogos) {
        const logoFoot = headCell({ id: COLUMN.LOGO, align: left })

        footCells.totals.splice(0, 0, logoFoot) // insert logo footer
        footCells.means.splice(0, 0, logoFoot) // insert logo footer
    }

    addPaddingRightToLastCell(footCells.totals)
    addPaddingRightToLastCell(footCells.means)
    // console.log('footCells:',footCells)
    return footCells
}

//#region Rows
export const createLseRolesRowData = props => {
    // console.log("createLseRolesRowData props: ", props)
    const { items, lseCompaniesMeta, portrait, showLogos } = props

    const rows = []
    initStats2(stats)
    const tooltip = ""

    items.forEach(item => {
        rows.push(createLseRolesRow({ tooltip, item, lseCompaniesMeta, portrait, showLogos }))
    })

    return rows
}

const createLseRolesRow = props => {
    // console.log('createLseRolesRow props:', props)
    const { item, lseCompaniesMeta, portrait, showLogos, tooltip } = props

    const { apptInfo, companyInfo, commonInfo, index, personInfo } = item
    // const position = apptInfo.position.title ? apptInfo.position.title : apptInfo.role
    const fontWeight = (apptInfo && apptInfo.position)
        ? getPositionFontWeight(apptInfo.position.typeBit)
        : normal

    // Aquire the lseCompanyMeta from lseCompaniesMeta via the companyMetaIndex
    const lseCompanyMeta = lseCompaniesMeta.items[companyInfo.companyMetaIndex]

    const tenseColor = apptInfo.tense >= 0 ? TENSE[apptInfo.tense].COLOR : COLOR.BLACK
    const startTip = apptInfo.from && !fromDateUnknown(new Date(apptInfo.from))
        ? formatDate(apptInfo.from, true)
        : null
    const untilTip = apptInfo.until && !isFarFutureDate(new Date(apptInfo.until)) ? formatDate(apptInfo.until, true) : null

    const officer = getCellWithTooltip({
        sortValue: commonInfo.name,
        tooltip,
        type: string,
        value: firstToLast(commonInfo.name),
    })

    const company = getCellWithTooltip({
        tooltip,
        paddingLeft: showLogos ? 0 : LAYOUT.HOME.PADDING.BORDER,
        type: string,
        value: lseCompanyMeta.names[0],
    })
    setStats(1, stats[COLUMN.COMPANY], true)

    const position = getCellWithTooltip({
        borderLeft,
        paddingLeft: LAYOUT.HOME.PADDING.BORDER,
        tooltip,
        type: string,
        value: apptInfo.position.title ? apptInfo.position.title : apptInfo.role,
    })

    const from = getCellWithTooltip({
        color: tenseColor,
        sortValue: apptInfo.from,
        tooltip: startTip,
        type: date,
        value: new Date(apptInfo.from),
    })

    // If apptInfo.from is in the future, set until to FUTURE_DATE so that we can identify it
    apptInfo.until = new Date(apptInfo.from) > new Date() ? JARGON.FUTURE_DATE : apptInfo.until
    const sortUntil = apptInfo.until ? apptInfo.until : JARGON.FUTURE_DATE // to force undefined & null dates to be in the future, for sorting
    const until = getCellWithTooltip({
        color: tenseColor,
        sortValue: sortUntil,
        tooltip: untilTip,
        type: date,
        value: new Date(apptInfo.until),
    })

    const tenure = commonLseTableData({ apptInfo, column: COLUMN.TENURE })

    setStats(apptInfo.tenureYears, stats[COLUMN.TENURE], true)

    const compensationSort = apptInfo.renumerationGBP ? apptInfo.renumerationGBP : 0
    const compensation = getCellWithTooltip({
        align: right,
        type: string,
        sortValue: compensationSort,
        value: formatInteger(apptInfo.renumerationGBP),
    })
    setStats(apptInfo.renumerationGBP, stats[COLUMN.COMPENSATION], true)

    const age = getCellWithTooltip({
        borderLeft,
        tooltip,
        type: number,
        value: personInfo.age
    })

    setStats(personInfo.age, stats[COLUMN.AGE])

    const sex = getCellWithTooltip(
        personInfo.sex === 1
            ? {
                align: right,
                tooltip: "female",
                type: string,
                value: "F",
            }
            : {
                align: right,
                tooltip: personInfo.sex === 0 ? "male" : "unknown",
                type: string,
                value: personInfo.sex === 0 ? "M" : JARGON.UNKNOWN,
            }
    )

    if (personInfo.sex === 0 || personInfo.sex === 1) {
        stats[COLUMN.SEX].total += personInfo.sex
        stats[COLUMN.SEX].numof++
    }

    const logo = showLogos
        ? lseCompanyMeta?.logo ?? "no logo"
        : null

    const cellWithTooltips = portrait
        ? [company, officer]
        : [company, officer, position, from, until, tenure, compensation, age, sex]

    addPaddingRightToLastCell(cellWithTooltips)

    return {
        index,
        fontWeight,
        link: `/company/${lseCompanyMeta.ids[0]}`,
        logo,
        cellWithTooltips,
    }
}

const getPositionFontWeight = positionType =>
    (positionType >= 0 && POSITION[positionType].FONT_WEIGHT)
        ? POSITION[positionType].FONT_WEIGHT : normal
//#endregion Rows

